import React from 'react';
import {useSpring, animated} from 'react-spring';
import rightLabel from './right_label.svg';
import leftLabel from './left_label.svg';

let style;

function Label(props) {

    if (props.mainSet) {
        style = {padding: "0.3em 0 0 .2em"};
    }
    else if (props.left) {
        style = {padding: "0.3em 0 0 2.8em"};
    } else {
        style = null;
    }

    return(
        <div className={props.class} style={props.mainSet ? {textAlign: "initial"} : null}  onMouseOver={props.onMouseFunc}>
            <img src={props.left ? leftLabel : rightLabel} style={{position: "absolute"}}/>
                <div className="guide_label" style={style}>{props.text}</div>
        </div>
    )
}

export default Label;